import React, { FC, useState } from 'react';

import { Outlet } from 'react-router-dom';

import { ProjectDirectoryLayout } from '@adsk/alloy-project-page-layout';
import { RemoteComponent, TabTitle } from '@adsk/exo-skeleton-react';

import ProjectsHeader from './ProjectsHeader';
import AlloyContextSubscriber from '../../components/AlloyContextSubscriber';
import { ConnectedAnnouncementBanner } from '../../components/AnnouncementBanner/ConnectedAnnouncementBanner';
import AppContentError from '../../components/AppContentError/AppContentError';
import { useFeatureFlag } from '../../components/LaunchDarklyProvider';
import RemoteNetworkBuildersProfileModal from '../../components/RemoteNetworkApiComponents/RemoteNetworkBuildersProfileModal';
import RemoteNetworkOnboardingACCUserModal from '../../components/RemoteNetworkApiComponents/RemoteNetworkOnboardingACCUserModal';

const OutletContainer: FC = () => {
  return (
    <>
      <RemoteComponent scope="accProjectList" moduleName="./ProductLinks" />
      <ProjectsHeader />
      <Outlet />
    </>
  );
};

const Projects = () => {
  const { value: useAccNetworkApiComponentsRemote } = useFeatureFlag<boolean>(
    'useAccNetworkApiComponentsRemote',
    false,
  );

  const [isBuildersProfileModalEnabled, setIsBuildersProfileModalEnabled] =
    useState<boolean | undefined>(false);
  const [isBuildersProfileModalShown, setIsBuildersProfileModalShown] =
    useState(false);

  return (
    <ProjectDirectoryLayout
      renderAboveLayout={() => <ConnectedAnnouncementBanner />}
      UNSAFE_showBuildersUserProfileModal={() => {
        setIsBuildersProfileModalShown(true);
      }}
      UNSAFE_isBuildersProfileModalEnabled={isBuildersProfileModalEnabled}
    >
      <TabTitle />
      <RemoteComponent
        scope="accProjectList"
        moduleName="./ProvidersContainer"
        renderError={() => <AppContentError />}
      >
        <AlloyContextSubscriber>
          <OutletContainer />
        </AlloyContextSubscriber>
      </RemoteComponent>
      {useAccNetworkApiComponentsRemote && (
        <>
          <RemoteNetworkOnboardingACCUserModal
            showModal={true}
            onSuccess={() => {
              setIsBuildersProfileModalEnabled(undefined);
            }}
          />
          <RemoteNetworkBuildersProfileModal
            setShowModal={setIsBuildersProfileModalShown}
            showModal={isBuildersProfileModalShown}
            isBuildersProfileModalEnabled={isBuildersProfileModalEnabled}
            setIsBuildersProfileModalEnabled={setIsBuildersProfileModalEnabled}
          />
        </>
      )}
    </ProjectDirectoryLayout>
  );
};

export default Projects;
